module.exports = __webpack_public_path__ + "static/img/contant_2.ae5a489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_2.jpg
// module id = UHTK
// module chunks = 0